import { handleUncaughtException } from './handleUncaughtException';
import { handleConnectionException } from './handleConnectionException';
import { handleServerException } from './handleServerException';
import Logger from '../../logger';

const EXCEPTION_TYPE = {
  UNCAUGHT: 'UNCAUGHT',
  API_REQUEST: 'API_REQUEST',
  NETWORK: 'NETWORK'
};

// eslint-disable-next-line import/prefer-default-export
export function handleException(
  exception,
  callbackActionCreator,
  showAlert = true,
  showNetworkErrorAlert = true
) {
  if (exception instanceof ErrorEvent) {
    // Uncaught error has happened
    console.error('Uncaught error has happened', exception);
    Logger.error({
      message: exception.message,
      stack: exception.error.stack,
      filename: exception.filename,
      colno: exception.colno,
      lineno: exception.lineno,
      type: EXCEPTION_TYPE.UNCAUGHT
    });
    return handleUncaughtException(exception, callbackActionCreator, showAlert);
  }
  if (exception instanceof Error && !exception.response && (exception.isAxiosError !== true || exception.message !== 'Network Error')) {
    // Uncaught error has happened
    console.error('Uncaught error has happened', exception);
    Logger.error({
      message: exception.message,
      stack: exception.stack,
      filename: exception.filename,
      colno: exception.colno,
      lineno: exception.lineno,
      type: EXCEPTION_TYPE.UNCAUGHT
    });
    return handleUncaughtException(exception, callbackActionCreator, showAlert);
  }
  if (exception.response) {
    // The response has been received from the server
    if (exception.response.data && exception.response.status === 401) {
      console.warn('API request: Unauthorized');
    } else {
      console.error('Exception from server', exception.response.data);
      Logger.error({
        message: `API request error: ${ (exception.response && exception.response.data && exception.response.data.message) || 'Unknown exception' }`,
        request: {
          method: exception.config && exception.config.method,
          URL: exception.config && exception.config.url,
          data: exception.config && exception.config.data
        },
        response: {
          ...exception.response.data
        },
        type: EXCEPTION_TYPE.API_REQUEST
      });
    }
    return handleServerException(exception.response, callbackActionCreator, showAlert);
  }
  // Network exception
  console.error('Network exception', exception);
  Logger.error({
    message: 'Network error',
    request: {
      method: exception.config && exception.config.method,
      URL: exception.config && exception.config.url
    },
    type: EXCEPTION_TYPE.NETWORK
  });
  return handleConnectionException(callbackActionCreator, showNetworkErrorAlert);
}
